// frontend/src/components/AboutSection.jsx

import { useState, useEffect, useRef } from "react";
import { uploadsUrl } from "../utils/api";
import "./AboutSection.css";

// 🔹 Read More Component
function ReadMore({ text, limit = 200 }) {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;
  if (text.length <= limit) return <p>{text}</p>;

  return (
    <p>
      {expanded ? text : text.slice(0, limit)}
      {!expanded && "…"}
      <button
        className="read-more-btn"
        onClick={() => setExpanded((e) => !e)}
      >
        {expanded ? " Read Less" : " Read More..."}
      </button>
    </p>
  );
}

// 🔹 Main Component
export default function AboutSection({ projectId, about = {} }) {
  // ✅ MATCH WITH YOUR API
  const {
    title = "",
    description = "",
    reasonTitle = "",
    points = [], // 🔥 THIS IS YOUR REAL DATA
  } = about;

  const [activeImg, setActiveImg] = useState(0);
  const [validImages, setValidImages] = useState([]);
  const intervalRef = useRef(null);

  // ✅ LOAD IMAGES
  useEffect(() => {
    const images = [
      "about_image1.webp",
      "about_image2.webp",
      "about_image3.webp",
    ];

    const checks = images.map((img) => {
      const url = uploadsUrl(projectId, img);
      return new Promise((res) => {
        const i = new Image();
        i.onload = () => res(url);
        i.onerror = () => res(null);
        i.src = url;
      });
    });

    Promise.all(checks).then((results) => {
      setValidImages(results.filter(Boolean));
    });
  }, [projectId]);

  // ✅ AUTO SLIDER
  useEffect(() => {
    if (validImages.length <= 1) return;

    intervalRef.current = setInterval(() => {
      setActiveImg((i) => (i + 1) % validImages.length);
    }, 3000);

    return () => clearInterval(intervalRef.current);
  }, [validImages]);

  // ❌ NOTHING TO SHOW
  if (!title && points.length === 0) return null;

  return (
    <section className="about-section section" id="about">
      <div className="container about-section__grid">

        {/* LEFT SIDE */}
        <div className="about-section__left">

          {/* ✅ KEY POINTS (FIXED) */}
          {points.length > 0 && (
            <div className="about-reason">
              <h2 className="about-reason__title">
                {reasonTitle || "Why Choose This Project"}
              </h2>

              <div className="about-reason__grid">
                {points.slice(0, 4).map((pt, i) => (
                  <div key={i} className="about-reason__card">
                    <div className="about-reason__label">
                      <span className="about-reason__dot" aria-hidden="true" />
                      <strong>{pt?.key || ""}</strong>
                    </div>
                    <span>{pt?.value || ""}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ✅ DESCRIPTION */}
          {title && (
            <div className="about-desc">
              <h3 className="about-desc__title">{title}</h3>
              <ReadMore text={description} limit={200} />
            </div>
          )}
        </div>

        {/* RIGHT SIDE (IMAGE SLIDER) */}
        {validImages.length > 0 && (
          <div className="about-section__right">
            <div className="about-slider">
              {validImages.map((url, i) => (
                <img
                  key={url}
                  src={url}
                  alt={`${title} ${i + 1}`}
                  className={`about-slider__img ${
                    i === activeImg ? "active" : ""
                  }`}
                  loading="lazy"
                  onError={(e) => (e.target.src = "/fallback.webp")}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}